import { z } from 'zod';
import { CarDamageElement } from '@/types/car/car-damage-element.type.ts';
import { CarDamageType } from '@/types/car/car-damage-type.type.ts';

export type CarDamageCreateForm = {
    symbolic_code?: CarDamageElement,
    type?: CarDamageType,
    photo?: File,
    paintwork_thickness?: number,
    comment?: string,
};

export type CarDamageCreateFormErrors = {
    symbolic_code?: string[],
    type?: string[],
    photo?: string[],
    paintwork_thickness?: string[],
    comment?: string[],
};

export const CarDamageCreateFormErrorsSchema = z.object({
    symbolic_code: z.array(z.string()).optional(),
    type: z.array(z.string()).optional(),
    photo: z.array(z.string()).optional(),
    paintwork_thickness: z.array(z.string()).optional(),
    comment: z.array(z.string()).optional(),
});
